// extracted by mini-css-extract-plugin
export default {"privacy":"Bullet_privacy__rMLxl","listLink":"Bullet_listLink__KHYDf"};